<template>
	<div class="generalInfo" :class="{ 'onlyView': getPermissionAction }">
		<div class="truckInfoBlock">
			<div class="truckInfo mb-2">
				<div class="truckInfoTitle">Truck info</div>
				<field
						width="290px"
						margin="0 0 10px 0"
						label="VIN #"
						placeholder="Enter VIN #"
						@updateInput="onInput($event, 'vin_code')"
						:setInputValue="vin_code"
						tooltip="VIN code must be unique!"
				></field>
				<field
						margin="0 0 10px 0"
						width="290px"
						label="Make"
						placeholder="Enter truck model"
						@updateInput="onInput($event, 'model')"
						:setInputValue="model"
				></field>
				<field
						margin="0 0 10px 0"
						width="290px"
						label="Plate#"
						placeholder="Enter plate#"
						@updateInput="onInput($event, 'plate')"
						:setInputValue="plate"
				></field>
			</div>
			<div class="truckInfo viewOnly" v-if="!isCreate">
				<div class="truckInfoTitle">Services</div>
				<field
						width="290px"
						margin="0 0 10px 0"
						label="Last sevice mileage"
						placeholder="-"
						@updateInput="onInput($event, 'vin')"
						:setInputValue="services['last_mileage']"
						icon="mi"
						is-disabled
				></field>
				<field
						margin="0 0 10px 0"
						width="290px"
						label="Next PM service mileage"
						placeholder="-"
						@updateInput="onInput($event, 'make')"
						:setInputValue="services['next_mileage_pm']"
						icon="mi"
						is-disabled
				></field>
				<field
						margin="0 0 10px 0"
						width="290px"
						type="text"
						label="Next alignment date"
						placeholder="-"
						:dateValue="services['next_date_alignment']"
						@updateDate="onDate($event, '')"
						is-date
						is-attach
						is-readonly
				></field>
				<field
						margin="0 0 10px 0"
						width="290px"
						type="text"
						label="Next annual inspection date"
						placeholder="-"
						:dateValue="services['next_date_inspection']"
						@updateDate="onDate($event, '')"
						is-date
						is-attach
						is-readonly
				></field>
			</div>
		</div>

		<div class="truckInfoRight">
			<div class="truckInfoBlock">
				<div class="truckInfo">
					<div class="truckInfoTitle">Drivers</div>
					<field
							:class-error="valid.driver_id && valid.driver_id.$error"
							margin="0 10px 0 0"
							width="290px"
							label="Driver"
							placeholder="Select driver"
							@updateAutocomplete="onAutocomplete($event, 'driver_id')"
							:autocompleteValue="driver_id"
							:items="drivers"
							:isClearable="false"
							is-autocomplete
							:is-disabled="!customerId"
					></field>
					<v-switch
							class="switchFrozen"
							:input-value="team"
							@change="onSwitch($event, 'team')"
							label="TEAM"
							color="success"
							:disabled="!customerId"
					></v-switch>
					<field
							v-if="team"
							margin="0 10px 0 0"
							width="290px"
							label="Driver"
							placeholder="Select driver"
							@updateAutocomplete="onAutocomplete($event, 'driver_second_id')"
							:autocompleteValue="driver_second_id"
							:items="drivers"
							:isClearable="false"
							is-autocomplete
							:is-disabled="!customerId"
					></field>
				</div>
				<div class="truckInfo">
					<div class="truckInfoTitle">ELD</div>
					<v-switch
							class="switchFrozen"
							:input-value="eld"
							@change="onSwitch($event, 'eld')"
							label="ELD"
							color="success"
					></v-switch>
					<field
							v-if="eld"
							:class-error="valid.eld_name && valid.eld_name.$error"
							margin="0 10px 0 0"
							width="290px"
							label="Name"
							placeholder="Enter ELD name"
							@updateInput="onInput($event, 'eld_name')"
							:setInputValue="eld_name"
							is-required
					></field>
				</div>
			</div>
			<!--			<customer-list
								:valid="valid"
								:select_companies_list="select_companies_list"
								:subcompanies="subcompanies"
								:subcompanies_type="subcompanies_type"
								:subcompanies_name="subcompanies_name"
								:subcompanies_status="subcompanies_status"
								@updateSubcompaniesType="onSubcompaniesType"
								@updateSubcompaniesList="onSubcompaniesList"
								@updateSubcompaniesDelete="onSubcompaniesDelete"
						></customer-list>-->
		</div>
	</div>
</template>

<script>
export default {
	name: "FirstTab",
	props: {
		getPermissionAction: Boolean,
		vin_code: String,
		plate: String,
		eld_name: String,
		eld: Boolean,
		driver_id: Number,
		team: Boolean,
		driver_second_id: Number,
		model: String,
		drivers: Array,
		customerId: Boolean,
		isCreate: Boolean,
		valid: Object,
		services: Object
	},
	methods: {
		onInput({ value }, key) {
			this.$emit('updateFirstTab', { value, key });
		},
		onDate(value, key) {
			this.$emit('updateFirstTab', { value, key });
		},
		onAutocomplete({ value }, key) {
			this.$emit('updateFirstTab', { value, key });
		},
		onSwitch(value, key) {
			this.$emit('updateFirstTab', { value, key });
		}
	}
};
</script>

<style scoped lang="scss">
@import "FirstTab";
</style>
